export const STATUS_PENDING = 1
export const STATUS_OPEN = 2
export const STATUS_CLOSED = 3
export const STATUS_SETTLED = 4

export const SIDE_A = 1
export const SIDE_B = 2

export const HIT_PENDING = 0
export const HIT_WIN = 1
export const HIT_LOSE = 2

export const PRIZE_VIP = 1
export const PRIZE_MASS = 2
export const PRIZE_SUPER_GROUP = 3
export const PRIZE_COIN = 4

const CIRCLE_NUMBERS = ['', '①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩', '⑪', '⑫', '⑬', '⑭', '⑮', '⑯']
const ROUND_STAGE_NAMES = {
  1: '1/16决赛',
  2: '1/8决赛',
  3: '1/4决赛',
  4: '半决赛',
  5: '季军赛',
  6: '决赛'
}

export function unwrapResponse (resp) {
  if (!resp || Number(resp.code) !== 200) {
    const error = new Error((resp && resp.msg) || '网络异常，请稍后重试')
    error.code = resp && resp.code
    error.response = resp
    throw error
  }
  return resp.data
}

export function formatDateTime (seconds) {
  if (!seconds) return '--'
  const date = new Date(Number(seconds) * 1000)
  const pad = n => String(n).padStart(2, '0')
  return `${pad(date.getMonth() + 1)}月${pad(date.getDate())}日 ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

export function circleNumber (value) {
  return CIRCLE_NUMBERS[value] || (value ? String(value) : '')
}

export function roundLabel (match) {
  const round = Number(match && match.round)
  const seq = circleNumber(Number(match && match.seq) || 0)
  const stageName = roundStageName(round) || (match && (match.stage_name || match.round_name))
  if (stageName) return `${stageName}${round >= 5 ? '' : seq}`
  return `第${seq || '-'}场`
}

export function roundStageName (round) {
  return ROUND_STAGE_NAMES[Number(round)] || ''
}

export function calcPercent (a, b) {
  const countA = Number(a) || 0
  const countB = Number(b) || 0
  const total = countA + countB
  if (total <= 0) return { a: 0, b: 0 }
  let percentA = Math.round(countA * 100 / total)
  let percentB = Math.round(countB * 100 / total)
  const diff = 100 - percentA - percentB
  if (diff !== 0) {
    if (countA >= countB) percentA += diff
    else percentB += diff
  }
  return { a: percentA, b: percentB }
}

export function matchPercents (match) {
  const fromServerA = match && match.percent_a
  const fromServerB = match && match.percent_b
  if (fromServerA !== undefined && fromServerB !== undefined) {
    const sum = Number(fromServerA) + Number(fromServerB)
    if (sum === 100 || sum === 0) return { a: Number(fromServerA) || 0, b: Number(fromServerB) || 0 }
  }
  return calcPercent(match && match.count_a, match && match.count_b)
}

export function isBettable (match) {
  return match && hasResolvedTeams(match) && Number(match.status) === STATUS_OPEN && !match.my_bet
}

export function matchState (match) {
  if (!match) return { text: '暂无场次', type: 'disabled', canBet: false }
  const status = Number(match.status)
  const myBet = match.my_bet
  if (status === STATUS_PENDING || !hasResolvedTeams(match)) {
    return { text: '对阵确定后开放竞猜，敬请期待', type: 'pending', canBet: false }
  }
  if (status === STATUS_OPEN && !myBet) {
    return { text: '可竞猜', type: 'open', canBet: true }
  }
  if (status === STATUS_OPEN && myBet) {
    return { text: '已参与，等待开赛 · 猜中后可抽好礼', type: 'joined', canBet: false }
  }
  if (status === STATUS_CLOSED && match.phase === 'running') {
    return { text: '比赛进行中，最终结果以官方终场（含加时/点球）为准', type: 'running', canBet: false }
  }
  if (status === STATUS_CLOSED && !myBet) {
    return { text: '本场竞猜已截止，你未参与 · 可前往其他未截止场次参与', type: 'closed', canBet: false }
  }
  if (status === STATUS_CLOSED) {
    return { text: '已参与，等待比赛结果', type: 'closed', canBet: false }
  }
  if (status === STATUS_SETTLED && myBet && Number(myBet.hit_result) === HIT_WIN) {
    return { text: '恭喜猜中，已获得 1 次抽奖机会', type: 'win', canBet: false }
  }
  if (status === STATUS_SETTLED && myBet && Number(myBet.hit_result) === HIT_LOSE) {
    return { text: '很遗憾，未猜中', type: 'lose', canBet: false }
  }
  if (status === STATUS_SETTLED && myBet && Number(myBet.hit_result) === HIT_PENDING) {
    return { text: '比赛已完赛，等待结果确认', type: 'ended', canBet: false }
  }
  if (status === STATUS_SETTLED) {
    return { text: '比赛已完赛，未参与竞猜', type: 'ended', canBet: false }
  }
  return { text: '比赛已截止，等待比赛结果', type: 'closed', canBet: false }
}

export function sideTeam (match, side) {
  return Number(side) === SIDE_B ? match.team_b : match.team_a
}

export function resolveWinnerSide (match) {
  if (!match) return 0
  const winner = String(match.winner || '').trim()
  if (winner === 'A' || winner === '1') return SIDE_A
  if (winner === 'B' || winner === '2') return SIDE_B
  const teamA = String(match.team_a || '').trim()
  const teamB = String(match.team_b || '').trim()
  if (winner && teamA && winner === teamA) return SIDE_A
  if (winner && teamB && winner === teamB) return SIDE_B
  const scoreText = String(match.result_score || '').trim()
  const parts = scoreText.split(/[-:：]/).map(part => part.trim())
  if (parts.length === 2) {
    const scoreA = Number(parts[0])
    const scoreB = Number(parts[1])
    if (!Number.isNaN(scoreA) && !Number.isNaN(scoreB) && scoreA !== scoreB) {
      return scoreA > scoreB ? SIDE_A : SIDE_B
    }
  }
  return 0
}

export function isResolvedTeamName (name) {
  const text = String(name || '').replace(/\s+/g, '')
  if (!text || text === '-' || text === '--') return false
  return !/(待公布|待定|胜者|负者|败者|胜方|负方|败方|tbd|tba|todo)/i.test(text)
}

export function hasResolvedTeams (match) {
  return isResolvedTeamName(match && match.team_a) && isResolvedTeamName(match && match.team_b)
}

export function prizeTypeName (type) {
  switch (Number(type)) {
    case PRIZE_VIP:
      return '会员'
    case PRIZE_MASS:
      return '群发次数'
    case PRIZE_SUPER_GROUP:
      return '超级群券'
    case PRIZE_COIN:
      return '默往币'
    default:
      return '奖品'
  }
}

export function grantStatusName (status) {
  return Number(status) === 2 ? '发放中' : '已到账'
}

export function isMockMode () {
  if (typeof window === 'undefined') return false
  const hostname = window.location.hostname
  const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1'
  return isLocalHost && /(?:\?|&)mock=1(?:&|$)/.test(window.location.search)
}

export function waitForNativeTouchEnd () {
  return new Promise(resolve => window.setTimeout(resolve, 1000))
}
